var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"month-picker-container mt-5"},[_c('div',{staticClass:"month-picker__header-title"},[_vm._v(" Select Bill Issue Date: ")]),_c('div',{staticClass:"date-picker-section"},[_c('v-date-picker',{ref:"startSelector",class:[{show: _vm.showDatepicker}, 'no-border'],attrs:{"select-attribute":{'aria-label': 'Bill Issue Date'},"drag-attribute":_vm.attribute,"value":_vm.selectedStartDate,"is-required":""},on:{"dayclick":function () {
	var args = [], len = arguments.length;
	while ( len-- ) args[ len ] = arguments[ len ];

	return _vm.handleDayClick.apply(void 0, [ 'start' ].concat( args ));
}}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }